import { createContext } from "react";

export type Language = "EN" | "DE";

const defaultInternationalizationContext = {
  language: "EN" as const,
  setLanguage: () => {},
};

export const InternationalizationContext = createContext<{
  language: Language;
  setLanguage: (language: Language) => void;
}>(defaultInternationalizationContext);
